import React, { useState, useCallback, ReactNode } from 'react';
import { JOBDA_SUPPORT_EMAIL } from '@domain/constant/contact';

import classnames from 'classnames/bind';
import styles from './faq.module.scss';
const cx = classnames.bind(styles);

const faqInfoList = [
  {
    question: '역량 기반으로 매칭 받는다는 것, 무슨 의미인가요?',
    answer: (
      <>
        응시자가 가진 역량을 필요로 하는 기업에 채용이 열리면, 가장 빠르게 응시자와 기업을 연결해드려요.
        <br />
        (역검 응시 완료 후 잡다에 프로필을 등록한 회원)
      </>
    ),
    type: 'type2',
  },
  {
    question: '역검 결과표로 얻을 수 있는 정보는 무엇이 있나요?',
    answer: (
      <>
        역검 결과를 바탕으로 개인의 역량 유형과 강약점을 알 수 있고, 역량 결과에 따라 취업에 활용할 수 있도록 면접
        가이드를 제공해드려요.
        <br />
        또한 역검 응시에 이상이 없었는지 체크하고 싶다면 결과표를 확인해주세요!
      </>
    ),
    type: 'type2',
  },
  {
    question: '역검, 다시 응시할 수 있나요?',
    answer: (
      <>
        역검 센터에서의 역검 응시 기회는 매월 5회(제휴 회원은 연 120회)로 초기화 돼요. (단, 미응시한 응시 기회는
        이월되지 않습니다.)
        <br />
        응시 중 문제가 생겨 정상적인 응시가 어려운 경우{' '}
        <a className={cx('mailLink')} href={`mailto:${JOBDA_SUPPORT_EMAIL}`}>
          {JOBDA_SUPPORT_EMAIL}
        </a>
        로 관련 내용을 문의해주세요.
      </>
    ),
    type: 'type2',
  },
  {
    question: '역량센터에서 응시한 역검, 어디에 활용할 수 있나요?',
    answer: (
      <>
        기업의 요구에 따라 역검에 응시하게 될 때, 잡다에서 이미 응시 완료한 결과가 있는 경우 역검 결과 불러오기를 활용할
        수 있어요.
      </>
    ),
    type: 'type1',
  },
  {
    question: '역검, 평가 기준이 궁금해요.',
    answer: (
      <>
        역검은 뇌신경과학을 기반으로 추출한 역량 기준을 통해, 응시자 고유의 잠재 역량이 기업문화 및 직무에 적합한지
        확인해요.
      </>
    ),
    type: 'type1',
  },
];

interface IFaqProps {
  index: number;
  question: string;
  answer: ReactNode;
  type: string;
}

const Faq = ({ index, question, answer, type }: IFaqProps) => {
  const [isShow, setIsShow] = useState(false);

  const onClickFaq = useCallback(() => {
    setIsShow(!isShow);
  }, [isShow]);

  return (
    <li className={cx('listItem', `listItem${index + 1}`)}>
      <a className={cx('listTitle', { on: isShow })} role="button" onClick={onClickFaq}>
        <em className={cx('question')}>{question}</em>
      </a>
      <div className={cx('answer', type, { on: isShow })}>{answer}</div>
    </li>
  );
};

const FaqList = () => {
  const faqList = faqInfoList.map((item, i) => {
    return <Faq key={i} index={i} question={item.question} answer={item.answer} type={item.type} />;
  });

  return <ul className={cx('faqList')}>{faqList}</ul>;
};

export default FaqList;
